import React from 'react';
import { Check } from 'lucide-react';
export const Dolor: React.FC = () => {
  const items = ['Le das el celular para que se entretenga un rato y termina pasando horas frente a la pantalla.', 'Se aburre rápidamente de cualquier actividad.', 'Ya no sabés qué ofrecerle para mantenerlo entretenido.', 'Pasa más tiempo viendo videos que creando.', 'Querés una alternativa divertida y saludable.', 'Buscás actividades que realmente aporten algo positivo.'];
  return <section className="py-8 px-4 bg-cream" data-id="element-50">
      <div className="max-w-2xl mx-auto" data-id="element-51">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-6" data-id="element-52">
          ¿Te resulta <span className="text-gold-dark" data-id="element-53">familiar</span>?
        </h2>

        <div className="bg-white rounded-3xl border-t-[6px] border-gold p-5 sm:p-7 shadow-card" data-id="element-54">
          <ul className="space-y-3" data-id="element-55">
            {items.map((item, idx) => <li key={idx} className="flex items-start gap-3 pb-3 border-b-2 border-dashed border-cream-dark last:border-b-0 last:pb-0" data-id="element-56">
                <div className="flex-shrink-0 mt-1 w-5 h-5 rounded-full bg-brandgreen flex items-center justify-center" data-id="element-57">
                  <Check className="text-white w-3 h-3" strokeWidth={4} data-id="element-58" />
                </div>
                <span className="text-violet font-semibold text-sm sm:text-base leading-snug" data-id="element-59">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-violet font-rounded font-bold text-base sm:text-lg mt-5 max-w-md mx-auto leading-snug" data-id="element-60">
          Si te identificaste con alguna de estas situaciones,{' '}
          <span className="text-gold-dark" data-id="element-61">
            esta biblioteca fue creada para vos.
          </span>
        </p>
      </div>
    </section>;
};